/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const InstagramIcon = createIcon({
    displayName: 'InstagramIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            fill: "url(#instagram__a)",
            d: "M12 5.441c2.136 0 2.39.008 3.233.047.78.035 1.203.166 1.485.275.374.145.64.319.92.598.28.28.454.547.598.92.11.282.24.706.276 1.486.038.844.046 1.097.046 3.233s-.008 2.389-.046 3.232c-.036.78-.166 1.204-.276 1.486a2.48 2.48 0 0 1-.598.92c-.28.28-.546.453-.92.598-.282.11-.705.24-1.485.276-.844.038-1.097.046-3.233.046s-2.39-.008-3.233-.046c-.78-.036-1.203-.166-1.485-.276a2.48 2.48 0 0 1-.92-.598 2.476 2.476 0 0 1-.599-.92c-.11-.282-.24-.706-.275-1.486-.038-.843-.046-1.096-.046-3.232s.008-2.39.046-3.233c.036-.78.166-1.204.275-1.486.146-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.275C9.611 5.45 9.864 5.44 12 5.44ZM12 4c-2.173 0-2.445.01-3.298.048-.852.039-1.433.174-1.942.372a3.923 3.923 0 0 0-1.417.923A3.92 3.92 0 0 0 4.42 6.76c-.198.509-.333 1.09-.372 1.942C4.01 9.555 4 9.827 4 12s.01 2.445.048 3.298c.039.852.174 1.433.372 1.942.205.526.478.972.923 1.417.445.445.89.718 1.417.923.509.198 1.09.333 1.942.372C9.555 19.99 9.827 20 12 20s2.445-.01 3.298-.048c.852-.039 1.433-.174 1.942-.372a3.923 3.923 0 0 0 1.417-.923 3.92 3.92 0 0 0 .923-1.417c.198-.509.333-1.09.372-1.942.039-.853.048-1.125.048-3.298s-.01-2.445-.048-3.298c-.039-.852-.174-1.433-.372-1.942a3.923 3.923 0 0 0-.923-1.417 3.925 3.925 0 0 0-1.417-.923c-.509-.198-1.09-.333-1.942-.372C14.445 4.01 14.173 4 12 4Zm0 3.892a4.108 4.108 0 1 0 0 8.216 4.108 4.108 0 0 0 0-8.216Zm0 6.775a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.334Zm4.27-7.897a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            fill: "url(#instagram__b)",
            d: "M12 5.441c2.136 0 2.39.008 3.233.047.78.035 1.203.166 1.485.275.374.145.64.319.92.598.28.28.454.547.598.92.11.282.24.706.276 1.486.038.844.046 1.097.046 3.233s-.008 2.389-.046 3.232c-.036.78-.166 1.204-.276 1.486a2.48 2.48 0 0 1-.598.92c-.28.28-.546.453-.92.598-.282.11-.705.24-1.485.276-.844.038-1.097.046-3.233.046s-2.39-.008-3.233-.046c-.78-.036-1.203-.166-1.485-.276a2.48 2.48 0 0 1-.92-.598 2.476 2.476 0 0 1-.599-.92c-.11-.282-.24-.706-.275-1.486-.038-.843-.046-1.096-.046-3.232s.008-2.39.046-3.233c.036-.78.166-1.204.275-1.486.146-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.275C9.611 5.45 9.864 5.44 12 5.44ZM12 4c-2.173 0-2.445.01-3.298.048-.852.039-1.433.174-1.942.372a3.923 3.923 0 0 0-1.417.923A3.92 3.92 0 0 0 4.42 6.76c-.198.509-.333 1.09-.372 1.942C4.01 9.555 4 9.827 4 12s.01 2.445.048 3.298c.039.852.174 1.433.372 1.942.205.526.478.972.923 1.417.445.445.89.718 1.417.923.509.198 1.09.333 1.942.372C9.555 19.99 9.827 20 12 20s2.445-.01 3.298-.048c.852-.039 1.433-.174 1.942-.372a3.923 3.923 0 0 0 1.417-.923 3.92 3.92 0 0 0 .923-1.417c.198-.509.333-1.09.372-1.942.039-.853.048-1.125.048-3.298s-.01-2.445-.048-3.298c-.039-.852-.174-1.433-.372-1.942a3.923 3.923 0 0 0-.923-1.417 3.925 3.925 0 0 0-1.417-.923c-.509-.198-1.09-.333-1.942-.372C14.445 4.01 14.173 4 12 4Zm0 3.892a4.108 4.108 0 1 0 0 8.216 4.108 4.108 0 0 0 0-8.216Zm0 6.775a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.334Zm4.27-7.897a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92Z"
        }),
        /*#__PURE__*/ _jsxs("defs", {
            children: [
                /*#__PURE__*/ _jsxs("radialGradient", {
                    id: "instagram__a",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientTransform: "matrix(0 -15.8571 14.7484 0 8.25 21.232)",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#FD5"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: ".1",
                            stopColor: "#FD5"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: ".5",
                            stopColor: "#FF543E"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "#C837AB"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("radialGradient", {
                    id: "instagram__b",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientTransform: "matrix(1.39126 6.95032 -28.64956 5.73484 1.32 5.153)",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#3771C8"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: ".128",
                            stopColor: "#3771C8"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "#60F",
                            stopOpacity: "0"
                        })
                    ]
                })
            ]
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            fill: "url(#instagram__a)",
            d: "M12 2.982c2.937 0 3.285.01 4.445.064 1.073.049 1.655.228 2.043.378.513.2.88.438 1.265.823.384.385.623.751.822 1.265.15.388.33.97.379 2.043.053 1.16.064 1.507.064 4.445 0 2.937-.011 3.285-.064 4.445-.05 1.072-.228 1.655-.379 2.042-.2.514-.438.88-.822 1.265a3.403 3.403 0 0 1-1.265.823c-.388.15-.97.33-2.043.378-1.16.053-1.508.064-4.445.064-2.937 0-3.285-.01-4.445-.064-1.073-.048-1.655-.227-2.043-.378a3.41 3.41 0 0 1-1.265-.823 3.404 3.404 0 0 1-.822-1.265c-.151-.387-.33-.97-.379-2.042-.053-1.16-.064-1.508-.064-4.445 0-2.938.011-3.285.064-4.445.05-1.073.228-1.655.379-2.043.2-.514.438-.88.822-1.265a3.404 3.404 0 0 1 1.265-.823c.388-.15.97-.33 2.043-.378 1.16-.053 1.508-.064 4.445-.064ZM12 1c-2.987 0-3.362.013-4.535.066-1.171.053-1.97.24-2.67.511a5.394 5.394 0 0 0-1.949 1.27 5.39 5.39 0 0 0-1.269 1.948c-.272.7-.458 1.5-.51 2.67C1.012 8.638 1 9.013 1 12s.013 3.362.066 4.535c.053 1.171.24 1.97.511 2.67a5.394 5.394 0 0 0 1.27 1.949 5.396 5.396 0 0 0 1.948 1.268c.7.273 1.5.459 2.67.512C8.638 22.987 9.013 23 12 23s3.362-.013 4.535-.066c1.171-.053 1.97-.24 2.67-.512a5.396 5.396 0 0 0 1.949-1.268 5.395 5.395 0 0 0 1.268-1.949c.272-.7.459-1.5.512-2.67.053-1.173.066-1.548.066-4.535s-.013-3.362-.066-4.535c-.053-1.171-.24-1.97-.512-2.67a5.395 5.395 0 0 0-1.268-1.949 5.398 5.398 0 0 0-1.949-1.269c-.7-.272-1.5-.458-2.67-.51C15.362 1.012 14.987 1 12 1Zm0 5.351a5.648 5.648 0 1 0 0 11.297 5.648 5.648 0 0 0 0-11.297Zm0 9.316a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334Zm5.872-10.859a1.32 1.32 0 1 0 0 2.64 1.32 1.32 0 0 0 0-2.64Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            fill: "url(#instagram__b)",
            d: "M12 2.982c2.937 0 3.285.01 4.445.064 1.073.049 1.655.228 2.043.378.513.2.88.438 1.265.823.384.385.623.751.822 1.265.15.388.33.97.379 2.043.053 1.16.064 1.507.064 4.445 0 2.937-.011 3.285-.064 4.445-.05 1.072-.228 1.655-.379 2.042-.2.514-.438.88-.822 1.265a3.403 3.403 0 0 1-1.265.823c-.388.15-.97.33-2.043.378-1.16.053-1.508.064-4.445.064-2.937 0-3.285-.01-4.445-.064-1.073-.048-1.655-.227-2.043-.378a3.41 3.41 0 0 1-1.265-.823 3.404 3.404 0 0 1-.822-1.265c-.151-.387-.33-.97-.379-2.042-.053-1.16-.064-1.508-.064-4.445 0-2.938.011-3.285.064-4.445.05-1.073.228-1.655.379-2.043.2-.514.438-.88.822-1.265a3.404 3.404 0 0 1 1.265-.823c.388-.15.97-.33 2.043-.378 1.16-.053 1.508-.064 4.445-.064ZM12 1c-2.987 0-3.362.013-4.535.066-1.171.053-1.97.24-2.67.511a5.394 5.394 0 0 0-1.949 1.27 5.39 5.39 0 0 0-1.269 1.948c-.272.7-.458 1.5-.51 2.67C1.012 8.638 1 9.013 1 12s.013 3.362.066 4.535c.053 1.171.24 1.97.511 2.67a5.394 5.394 0 0 0 1.27 1.949 5.396 5.396 0 0 0 1.948 1.268c.7.273 1.5.459 2.67.512C8.638 22.987 9.013 23 12 23s3.362-.013 4.535-.066c1.171-.053 1.97-.24 2.67-.512a5.396 5.396 0 0 0 1.949-1.268 5.395 5.395 0 0 0 1.268-1.949c.272-.7.459-1.5.512-2.67.053-1.173.066-1.548.066-4.535s-.013-3.362-.066-4.535c-.053-1.171-.24-1.97-.512-2.67a5.395 5.395 0 0 0-1.268-1.949 5.398 5.398 0 0 0-1.949-1.269c-.7-.272-1.5-.458-2.67-.51C15.362 1.012 14.987 1 12 1Zm0 5.351a5.648 5.648 0 1 0 0 11.297 5.648 5.648 0 0 0 0-11.297Zm0 9.316a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334Zm5.872-10.859a1.32 1.32 0 1 0 0 2.64 1.32 1.32 0 0 0 0-2.64Z"
        }),
        /*#__PURE__*/ _jsxs("defs", {
            children: [
                /*#__PURE__*/ _jsxs("radialGradient", {
                    id: "instagram__a",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientTransform: "matrix(0 -21.8036 20.279 0 6.844 24.694)",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#FD5"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: ".1",
                            stopColor: "#FD5"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: ".5",
                            stopColor: "#FF543E"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "#C837AB"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("radialGradient", {
                    id: "instagram__b",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientTransform: "rotate(78.681 -2.92 -.346) scale(9.74629 40.1746)",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#3771C8"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: ".128",
                            stopColor: "#3771C8"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "#60F",
                            stopOpacity: "0"
                        })
                    ]
                })
            ]
        })
    ]
});
InstagramIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'InstagramIcon'
};
export { InstagramIcon };

//# sourceMappingURL=instagram.js.map